import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 *  @description
 *  5 withholding tax certificate（50 Tawi)
 */
import { getAllListFn as _getAllListFn } from '@/api/org/position';
import { sysInfoFn as _sysInfoFn } from '@/api/org/per';
import { getTawiList, countNoEmail, sendTawiMail, downloadTawiPdf } from '@/api/payroll/prove-download';
import Dep from '@/components/department';
export default {
  components: {
    Dep: Dep
  },
  data: function data() {
    return {
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear();
        }
      },
      leaveDate: [],
      form: {
        year: new Date().getFullYear().toString(),
        state: '',
        // 员工在职状态
        begin_leave_date: '',
        // 离职开始时间
        end_leave_date: '',
        // 离职结束时间
        search_name: '',
        // 员工信息
        job_title_id: '',
        // 职位id
        department_id: '',
        // 部门id
        page: 1,
        page_size: 20
      },
      pageSizes: [20, 50, 100],
      pageData: {},
      tableSelectArr: [],
      isAll: false,
      visible: false,
      count: 0,
      batchType: '',
      emalType: '',
      emailInfo: '',
      current: null,
      emailData: null,
      posiAllList: [],
      posiOptions: [],
      sysInfoArr: {
        state: [],
        // 在职状态
        salary_method: [],
        // 发薪方式
        settlement_type: [],
        // 结算类型
        formal: [] // 员工属性
      },

      tableData: [],
      tableColumn: []
    };
  },
  created: function created() {
    this.getAllListFn();
    this.sysInfoFn();
  },
  methods: {
    sysInfoFn: function sysInfoFn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) _this.sysInfoArr = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getAllListFn: function getAllListFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getAllListFn();
            case 2:
              res = _context2.sent;
              _this2.posiAllList = res.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    remoteMethod: function remoteMethod(query) {
      // 处理职位数据
      var obj = this.posiAllList.filter(function (v) {
        return v.job_title_name.toLowerCase().indexOf(query.toLowerCase()) > -1;
      });
      this.posiOptions = query !== '' ? obj : [];
    },
    changeDep: function changeDep(a) {
      // 获取部门id
      this.form.department_id = a[0] && a[0].department_id;
    },
    changeLeaveData: function changeLeaveData(v) {
      // 离职日期
      if (v) {
        this.form.begin_leave_date = v[0];
        this.form.end_leave_date = v[1];
      } else {
        this.form.begin_leave_date = '';
        this.form.end_leave_date = '';
      }
    },
    currentChangeHandle: function currentChangeHandle(val) {
      this.search(val);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.form.page_size = val;
      this.search(1);
    },
    search: function search(page) {
      var _this3 = this;
      // 查询
      this.form.page = page;
      getTawiList(this.form).then(function (res) {
        if (res && res.code === 1) {
          _this3.tableColumn = res.data.header;
          _this3.tableData = res.data.body;
          _this3.pageData = res.data.page_data;
          if (_this3.isAll) _this3.$refs.table.toggleAllSelection();
        } else {
          _this3.tableData = [];
          _this3.tableColumn = [];
          _this3.pageData = {};
        }
      });
    },
    onAllSelect: function onAllSelect() {
      // 选择全部
      this.isAll = true;
      if (this.tableSelectArr.length !== this.tableData) {
        this.$refs.table.toggleAllSelection();
      }
    },
    tableSelectHandle: function tableSelectHandle(val) {
      // 表格选中
      this.tableSelectArr = val;
    },
    onSelect: function onSelect(selection, row) {
      this.isAll = false;
    },
    onSelectAll: function onSelectAll(selection, row) {
      if (!selection.length) this.isAll = false;
    },
    onBatch: function onBatch(val, row) {
      // 批量发送/下载 打开弹窗
      this.visible = true;
      this.batchType = val;
      this.current = null;
      this.emailData = null;
      if (row) {
        this.current = row;
        this.emailData = {
          1: this.current.personal_email,
          2: this.current.enterprise_email,
          3: ''
        };
      }
    },
    changeType: function changeType() {
      var _this4 = this;
      // 多少人不能发送
      if (this.current) {
        var email = this.emalType === '1' ? !this.current.personal_email : !this.current.enterprise_email;
        this.count = email ? 1 : 0;
        return;
      }
      if (this.isAll) {
        countNoEmail({
          type: this.emalType
        }).then(function (res) {
          if (res && res.code === 1) {
            _this4.count = res.data;
          } else {
            _this4.count = 0;
          }
        });
      } else {
        var _email = this.tableSelectArr.filter(function (item) {
          return _this4.emalType === '1' ? !item.personal_email : !item.enterprise_email;
        });
        this.count = _email.length;
      }
    },
    onClose: function onClose() {
      this.visible = false;
      this.current = null;
      this.emailData = null;
      this.emalType = '';
    },
    onDownload: function onDownload() {
      var _this5 = this;
      var query = {
        year: this.form.year,
        staff_id: []
      };
      if (!this.isAll) {
        query.staff_id = this.tableSelectArr.map(function (item) {
          return item.staff_id;
        });
      }
      downloadTawiPdf(query).then(function (res) {
        if (res && res.code === 1) {
          _this5.$message.success(res.message);
          _this5.tableSelectArr = [];
          _this5.$refs.table.clearSelection();
          _this5.isAll = false;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this6 = this;
      var query = {
        year: this.form.year,
        type: this.emalType,
        staff_id: []
      };
      if (this.current) {
        query.staff_id = [this.current.staff_id];
        query.email = this.emailData[this.emalType];
      } else if (!this.isAll) {
        query.staff_id = this.tableSelectArr.map(function (item) {
          return item.staff_id;
        });
      }
      sendTawiMail(query).then(function (res) {
        if (res && res.code === 1) {
          _this6.$message.success(res.message);
          if (!_this6.current) {
            _this6.tableSelectArr = [];
            _this6.$refs.table.clearSelection();
            _this6.isAll = false;
          }
          _this6.onClose();
        }
      });
    }
  }
};